import { api } from '../Configs/AxiosConfigs'
import { defineCancelApiObject } from '../Configs/AxiosUtils'

export const AccountCategoryAPIs = {
  getAllCategoryTypeAvailablePublic: async function (cancel = false) {
    const response = await api.request({
      url: `/v1/categorytype/available/public`,
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: {},
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  getAllCategoryTypeWiseAvailablePublic: async function (categoryTypeId, cancel = false) {
    const response = await api.request({
      url: `/v1/categories/typewise/available/public/${categoryTypeId}`,
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: {},
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  updateCategoryType: async function (categoryTypeObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/category`,
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: categoryTypeObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  userCategoryStatus: async function (statusObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/category/status`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: statusObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  getUserCategoryStatusBoolean: async function (statusObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/category/status/boolean`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: statusObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(AccountCategoryAPIs)
